var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex justify-content-center pt-5"},[(!_vm.user.uid)?_c('router-link',{attrs:{"to":{
      name: 'login',
    }}},[_c('b-btn',{staticClass:"btn-calcul btn-calcul--larger uppercase",attrs:{"size":"lg"}},[_c('b-icon-calculator',{attrs:{"aria-hidden":"true"}}),_vm._v(" je fais mon calcul ")],1)],1):_vm._e(),(_vm.user.uid)?_c('router-link',{attrs:{"to":{
      name: 'reportNew',
    }}},[_c('b-btn',{staticClass:"btn-calcul btn-calcul--larger uppercase",attrs:{"size":"lg"}},[_c('b-icon-calculator',{attrs:{"aria-hidden":"true"}}),_vm._v(" je fais mon calcul ")],1)],1):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }